import { useSelector } from 'react-redux';

import { languages } from 'src/config/i18n.config.mjs';
import { getUserInformation } from 'src/modules/user/selectors/userSelectors';

export const isCurrentLanguageSupported = () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { languagePreferences } = useSelector(getUserInformation);

    return languagePreferences && !!languages[languagePreferences[0]];
};
